// extracted by mini-css-extract-plugin
export default {"sectionButton":"styles_sectionButton__DLVhH"};